import { topicTags } from '@/mocks/homepage';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-900">热门话题</h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">当前最受关注的擦边内容话题标签</p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 md:gap-3">
          {topicTags.map((tag) => (
            <a
              key={tag.name}
              href="#"
              onClick={(e) => e.preventDefault()}
              className={`inline-flex items-center gap-1.5 px-3 py-1.5 md:px-4 md:py-2 rounded-full text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                tag.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200'
                  : 'bg-secondary-100 text-secondary-700 hover:bg-secondary-200'
              }`}
            >
              {tag.hot && <i className="ri-fire-line text-primary-500 text-xs"></i>}
              <span>{tag.name}</span>
              <span className={`text-xs ${tag.hot ? 'text-primary-500' : 'text-secondary-500'}`}>{tag.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}